import React from 'react';
import Container from 'tbk-components/src/components/Container';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IButtonListProps extends IBaseElementProps {
	buttons: ILink[];
}

/**
 * Button List
 * @icon button
 * @block
 */
const ButtonList: React.FC<IButtonListProps> = ({ buttons = [] }) => (
	<div className="button-list container">
		{buttons.map((button, index) => (
			<Button
				key={index}
				size="lg"
				classNames={['button-list__button']}
				{...button}
			/>
		))}
	</div>
);

export default ButtonList;
